// src/pages/admin/AdminOwners.js
// Gestion des propriétaires connectée à l'API - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROUTES from '../../constants/routes';
import apiClient from '../../api/client';

const AdminOwners = () => {
  const navigate = useNavigate();
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const loadOwners = async () => {
      setLoading(true);
      try {
        const result = await apiClient.get('/endpoints/owners.php?action=list');
        setOwners(result.owners || []);
      } catch (err) {
        setOwners([]);
      } finally {
        setLoading(false);
      }
    };
    loadOwners();
  }, []);

  const filtered = owners.filter(
    (o) => !search || o.name.toLowerCase().includes(search.toLowerCase()) || o.phone.includes(search)
  );

  const handleWhatsApp = (phone) => {
    window.open(`https://wa.me/${phone.replace(/\D/g, '')}`, '_blank');
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '900px', margin: '0 auto', backgroundColor: '#0A0E1A' },
    header: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', position: 'sticky', top: 0, backgroundColor: '#0A0E1A', zIndex: 50 },
    backButton: { background: 'none', border: 'none', color: '#FFFFFF', fontSize: '20px', cursor: 'pointer' },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    searchInput: { margin: '16px 20px', padding: '12px 16px', backgroundColor: '#111827', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '8px', color: '#FFFFFF', fontSize: '14px', outline: 'none' },
    list: { display: 'flex', flexDirection: 'column', gap: '12px', padding: '0 20px 40px' },
    card: { display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', backgroundColor: '#162033', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.1)' },
    avatar: { width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(255, 215, 0, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 },
    body: { flex: 1 },
    name: { fontSize: '15px', fontWeight: '600', color: '#FFFFFF' },
    info: { fontSize: '13px', color: '#A0AEC0', marginTop: '2px' },
    badge: { fontSize: '12px', color: '#FFD700', marginTop: '2px' },
    whatsappBtn: { padding: '8px 14px', backgroundColor: 'rgba(72, 187, 120, 0.15)', color: '#48BB78', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
    empty: { textAlign: 'center', padding: '48px', color: '#A0AEC0', fontSize: '14px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Propriétaires | Fynho Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(ROUTES.ADMIN_DASHBOARD)}>←</button>
        <div style={styles.title}>Propriétaires</div>
      </div>

      <input type="text" style={styles.searchInput} placeholder="Rechercher un propriétaire..." value={search} onChange={(e) => setSearch(e.target.value)} />

      <div style={styles.list}>
        {loading ? (
          <div style={styles.empty}>Chargement...</div>
        ) : filtered.length === 0 ? (
          <div style={styles.empty}>Aucun propriétaire trouvé</div>
        ) : (
          filtered.map((owner) => (
            <div key={owner.id} style={styles.card}>
              <div style={styles.avatar}>👤</div>
              <div style={styles.body}>
                <div style={styles.name}>{owner.name}</div>
                <div style={styles.info}>📞 {owner.phone} {owner.city ? `· ${owner.city}` : ''}</div>
                <div style={styles.badge}>🏡 {owner.listings_count} annonce(s)</div>
              </div>
              <button style={styles.whatsappBtn} onClick={() => handleWhatsApp(owner.phone)}>💬</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminOwners;